export const scrollTop = () => {
  return document.getElementById('root')?.scrollTo({
    top: 0,
  });
};
